import { render, staticRenderFns } from "./TemplateTypesTab.vue?vue&type=template&id=91409826&scoped=true"
import script from "./TemplateTypesTab.vue?vue&type=script&lang=js"
export * from "./TemplateTypesTab.vue?vue&type=script&lang=js"
import style0 from "./TemplateTypesTab.vue?vue&type=style&index=0&id=91409826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91409826",
  null
  
)

export default component.exports